// 訊息模版總覽（唯讀）：反映目前代碼實際使用嘅對外訊息格式
// 來源：whatsapp-connector/src/session.ts、ai-core/src/index.ts

const HANDOFF_TEMPLATE = `【人工干預通知】
客戶：{客戶電話號碼}
最後訊息：{客戶最後一段話}
👉 立即回覆：https://wtsaibot.com/c/{8位短碼}
AI 已自動暫停 30 分鐘，請經控制台直接回覆客戶；逾時會自動恢復 AI。`;

const SECTIONS = [
  {
    icon: "🙋",
    title: "人工干預通知（轉真人時發送俾通知手機）",
    body: HANDOFF_TEMPLATE,
    notes: [
      "觸發時機：客人要求轉真人、AI 連續答不上、額度耗盡",
      "發送對象：租戶設定嘅「人工干預通知手機」（最多 3 個）",
      "短連結 /c/{短碼} 會 302 轉去完整控制台連結；舊 /console/{短碼} 仍然有效",
      "控制台 PIN = 通知手機號碼尾 4 位；驗證成功後裝置會記住 30 分鐘",
    ],
  },
  {
    icon: "📱",
    title: "手機指令（由通知手機發送到發送號碼）",
    body: `/pause {客戶電話} — 暫停該客戶嘅 AI（30 分鐘）
/resume {客戶電話} — 提前恢復 AI
/reply {客戶電話} {訊息} — 經系統回覆客戶並記錄
/status {客戶電話} — 查詢該客戶目前狀態＋最近對話`,
    notes: [
      "指令只接受「人工干預通知手機」清單內嘅號碼發出，其他人發送會被當普通客人訊息處理",
      "控制台網頁版有相同功能（延長暫停／恢復 AI／直接回覆／查看對話），一般用控制台更方便",
    ],
  },
  {
    icon: "🤖",
    title: "AI 回覆結尾（觸發轉真人時自動附加）",
    body: "已為您轉接專人處理，請稍候。",
    notes: [
      "AI 回覆中嘅所有連結會被代碼統一移除（stripHandoffLinks），連結只會出現喺通知手機嘅訊息，唔會發俾客人",
    ],
  },
  {
    icon: "🔁",
    title: "話術池（隨機挑選，避免制式重複）",
    body: `額度耗盡（節錄）：
・免費額度已耗盡，請聯絡客服升級或轉接專人。
・您的試用額度已經用完囉，麻煩聯絡我們升級方案，或轉接真人為您服務。

系統忙碌（節錄）：
・系統忙碌中，請稍後再試。
・現在處理量比較大，麻煩您稍等一下再問一次喔。`,
    notes: [
      "話術池定義喺 ai-core/src/index.ts（BUSY_FALLBACK_VARIANTS、QUOTA_EXCEEDED_VARIANTS）同 session.ts（GENERIC_ERROR_VARIANTS）",
      "偵測到客人情緒唔好時，額度耗盡訊息會自動加同理開場白",
    ],
  },
];

export default function TemplatesPage() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-100">📨 訊息模版</h1>
        <p className="text-sm text-slate-400 mt-1">
          系統實際使用嘅對外訊息格式（唯讀，跟代碼同步）。要修改模版內容，需改源碼後重新部署。
        </p>
      </div>

      <div className="space-y-4">
        {SECTIONS.map((s) => (
          <div key={s.title} className="bg-slate-900 rounded-xl border border-slate-800 p-5">
            <h2 className="text-sm font-semibold text-slate-100 mb-3">
              {s.icon} {s.title}
            </h2>
            <pre className="p-4 bg-slate-950 rounded-lg text-sm text-emerald-300 whitespace-pre-wrap font-mono border border-slate-800 mb-3">
              {s.body}
            </pre>
            <ul className="space-y-1">
              {s.notes.map((n, i) => (
                <li key={i} className="text-xs text-slate-500 flex gap-2">
                  <span className="text-slate-600">•</span>
                  <span>{n}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
